<template>
  <section id="main-slider-1" class="main-swiper-container">
    <swiper
      class="swiper-main"
      :modules="modules"
      :slides-per-view="1"
      :pagination="{ clickable: true }"
      :autoplay="{
        delay: 3000,
        disableOnInteraction: true,
      }"
    >
      <swiper-slide class="swiper-main-slide swiper-main-slide">
        <div class="first-swiper__image first-swiper__image-0"></div>
      </swiper-slide>

      <swiper-slide class="swiper-main-slide swiper-main-slide">
        <div class="first-swiper__image first-swiper__image-1"></div>
      </swiper-slide>

      <swiper-slide class="swiper-main-slide">
        <SliderComponent>
          <template #video>
            <video autoplay muted loop>
              <source
                media="(max-width: 767px)"
                type="video/mp4"
                src="@/img/pics/backgrounds/main-slider/main-slide-2-m.mp4"
              />
              <source
                media="(min-width: 768px) and (max-width: 1180px)"
                type="video/mp4"
                src="@/img/pics/backgrounds/main-slider/main-slide-2-t.mp4"
              />
              <source
                type="video/mp4"
                src="@/img/pics/backgrounds/main-slider/main-slide-2.mp4"
              />
            </video>
          </template>
        </SliderComponent>
      </swiper-slide>

      <!-- <swiper-slide class="swiper-main-slide">
        <div class="first-swiper__image first-swiper__image-2"></div>
      </swiper-slide> -->
      <!-- <swiper-slide class="swiper-main-slide">
        <div class="first-swiper__image first-swiper__image-3"></div>
      </swiper-slide> -->
    </swiper>
  </section>
</template>
<script>
import siteData from "@/config.json";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Autoplay } from "swiper";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/autoplay";
import TimeCounter from "./TimeCounter.vue";
import SliderComponent from "./SliderComponent.vue";
export default {
  name: "MainSlider",
  components: {
    Swiper,
    SwiperSlide,
    TimeCounter,
    SliderComponent,
  },
  data() {
    return {
      modules: [Pagination, Autoplay],
      know_more: siteData.know_more,
      sliders: siteData.main_slider,
    };
  },
  methods: {
    toggleRequestForm(event) {
      this.emitter.emit("open-request-form", {
        open: false,
        title:
          "Оставьте заявку на звонок менеджера и зафиксируйте лучшие условия на покупку Chery",
        form_position: "формы  Зафиксируйте лучшие условия ",
      });
    },
  },
};
</script>
